export default {"src":"/_next/static/media/finalReport.c7b3d8cc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};